// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__I2YUJ","dropdown_content":"dropdown_dropdown_content__j4WRf"};